const common = {
  specificBidAmount: 500,
  cutOffBidAmount: 25000,
  bidFee: 500,
  bookingFee: 50000,
  cdn: 'https://watabid-static.imgix.net',
  countryCode: [
    {
      country: 'India +91',
      codes: '+91',
      minDigit: 10,
      maxDigit: 10,
    },
    {
      country: 'Singapore +65',
      codes: '+65',
      minDigit: 7,
      maxDigit: 12,
    },
    {
      country: 'Australia +61',
      codes: '+61',
      minDigit: 7,
      maxDigit: 12,
    },
    {
      country: 'US or Canada +1',
      codes: '+1',
      minDigit: 7,
      maxDigit: 12,
    },
    {
      country: 'Malaysia +60',
      codes: '+60',
      minDigit: 7,
      maxDigit: 12,
    },
    {
      country: 'UAE +971',
      codes: '+971',
      minDigit: 7,
      maxDigit: 12,
    },
    {
      country: 'Bahrain +973',
      codes: '+973',
      minDigit: 7,
      maxDigit: 12,
    },
    {
      country: 'Iraq +964',
      codes: '+964',
      minDigit: 7,
      maxDigit: 12,
    },
    {
      country: 'Kuwait +965',
      codes: '+965',
      minDigit: 7,
      maxDigit: 12,
    },
    {
      country: 'Oman +968',
      codes: '+968',
      minDigit: 7,
      maxDigit: 12,
    },
    {
      country: 'Qatar +974',
      codes: '+974',
      minDigit: 7,
      maxDigit: 12,
    },
    {
      country: 'Saudi Arabia +966',
      codes: '+966',
      minDigit: 7,
      maxDigit: 12,
    },
    {
      country: 'UK +44',
      codes: '+44',
      minDigit: 7,
      maxDigit: 12,
    },
    {
      country: 'Germany +49',
      codes: '+49',
      minDigit: 7,
      maxDigit: 12,
    },
    {
      country: 'New Zealand +64',
      codes: '+64',
      minDigit: 7,
      maxDigit: 12,
    },
    {
      country: 'France +33',
      codes: '+33',
      minDigit: 7,
      maxDigit: 12,
    },
    {
      country: 'Switzerland +41',
      codes: '+41',
      minDigit: 7,
      maxDigit: 12,
    },
    {
      country: 'South Africa +27',
      codes: '+27',
      minDigit: 7,
      maxDigit: 12,
    },
    {
      country: 'Spain +34',
      codes: '+34',
      minDigit: 7,
      maxDigit: 12,
    },
  ],
  totalFavUnits: 10,
};

export default common;



// WEBPACK FOOTER //
// ./src/constants/common.js